import { ApiErrorResponseWithCode } from '@vfde-sails/utils';
import { ErrorMessage } from '../enum';

export const isApiError = (error: unknown): error is ApiErrorResponseWithCode =>
    null !== error
        && 'object' === typeof error
        && 'constructor' in error
        && error.constructor.name === ApiErrorResponseWithCode.name;

export const isNonUniqueAddressError = (error: unknown): error is Error =>
    null !== error
            && error instanceof Error
            && error.message === ErrorMessage.NON_UNIQUE_ADDRESS;

export const isAddressNotFoundError = (error: unknown): error is Error =>
    null !== error
            && error instanceof Error
            && error.message === ErrorMessage.ADDRESS_NOT_FOUND;

export const isEmptyResponeError = (error: unknown): error is Error =>
    null !== error
            && error instanceof Error
            && error.message === ErrorMessage.EMPTY_RESPONSE;

export const isAddressError = (error: unknown): error is Error =>
    isNonUniqueAddressError(error) || isAddressNotFoundError(error);

export const isAvcError = (error: unknown): error is Error=>
    isApiError(error) ||
    isAddressError(error) ||
    isEmptyResponeError(error);
